/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2023-02-03 09:36:55
 * @Description: 
 */
import React from "react";
import FTLinkToAIGC from "src/components/FTLinkToAIGC/FTLinkToAIGC";
import FTScrollbar from "src/components/FTScrollBar/FTScrollBar";
import ToolLeftSearchList from "src/pages/ToolLeft/ToolLeftSearchList/ToolLeftSearchList"
import { useChoicenessList, useCurrentEffect, useEffectClassifyMap, useSearchList, useSearchText } from "src/hooks";
import EffectListCollapse from "./EffectListCollapse/EffectListCollapse";
import "./ToolLeftEffectList.scss"
import FTLang from "src/utils/FTLang";
import FTImageStore from "src/store/FTImageStore";

export default function ToolLeftEffectList() {
  let effectListMap = useEffectClassifyMap()
  let choicenessList = useChoicenessList()
  let searchList = useSearchList()
  let [searchText] = useSearchText()
  let currentEffect = useCurrentEffect()
  let scrollRef = React.createRef()

  let [init, setInit] = React.useState(false)

  React.useEffect(() => {
    if(currentEffect && !init) {
      setInit(true)
      let ele = document.querySelector(`.${currentEffect.name.replace(/ /g, () => "_")}`)
      let eleRect = ele && ele.getBoundingClientRect()
      let scrollRect = (scrollRef.current as unknown as any).current.getBoundingClientRect()
      if(eleRect && scrollRect) {
        if(eleRect.top - scrollRect.top - scrollRect.height > -200) {
          (scrollRef.current as unknown as any).scrollMove("bottom", eleRect.top - scrollRect.top - scrollRect.height / 2)
        }
      }
    }
  }, [currentEffect])

  React.useEffect(() => {
    if(effectListMap.length) {
      if(FTImageStore.defaultEffectClassify) {
        let ele = document.getElementById(FTImageStore.defaultEffectClassify)
        let eleRect = ele && ele.getBoundingClientRect()
        let scrollRect = (scrollRef.current as unknown as any).current.getBoundingClientRect()
        if(eleRect && scrollRect) {
          if(eleRect.top - scrollRect.top - scrollRect.height > -200) {
            (scrollRef.current as unknown as any).scrollMove("bottom", eleRect.top - scrollRect.top)
          }
        }
        FTImageStore.defaultEffectClassify = ""
      }
    }
  }, [effectListMap])

  React.useEffect(() => {
    if(scrollRef.current) {
      let current = (scrollRef.current as unknown as any);
      current.scrollMove("top", current.current.scrollTop);
    }
  }, [searchList])

  let searchTextMatch = searchText.match(/.*[a-zA-Z0-9]+.*/)
  return <div className="toolleft_effect_list">
    {effectListMap.length && <FTScrollbar onRef={scrollRef} theme="white">
      { !searchTextMatch && searchList.length === 0 && <div className="toolleft_effect_list_scroll">
        <EffectListCollapse key="choiceness" effectList={choicenessList} title={FTLang._("goart_choiceness_title")} needCollapse={false} isCollapse={true} />
        <FTLinkToAIGC />
        {
          effectListMap && effectListMap.map((item: any, index: number) => {
            return <EffectListCollapse key={index} effectList={item.list} title={item.title} isCollapse={item.collapse} />
          })
        }
      </div>}
      {
        searchTextMatch && <ToolLeftSearchList searchList={searchList} />
      }
      <div style={{height: "20px"}}></div>
    </FTScrollbar>}
  </div>
}